import React, { useEffect, useState, useContext, useRef } from 'react';


function SvgInverter({Data, x, y, width, height, phase }) {
    return (<svg id={"inverter_"+Data.SN} x={x} y={y} width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.48 71.65">
        <rect x="1.53" y="1.64" width="120.48" height="68.65" rx="3.63" style={{ fill: '#1d80b5' }} />
        <rect x="26.05" y="28.12" width="72.42" height="15.85" rx="1.19" style={{ fill: '#fff' }} />
        <rect x="55.31" y="30.61" width="13.94" height="11.03" rx="0.72" style={{ fill: '#1d80b5' }} />
        <rect x="1.5" y="1.5" width="120.48" height="68.65" rx="3.63" style={{ stroke: '#fff', strokeWidth: 3, fill: 'none' }} />
        <ellipse cx="30.31" cy="36.16" rx="1.16" ry="1.21" style={{ fill: '#1d80b5' }} />
        <ellipse cx="37.58" cy="36.16" rx="1.16" ry="1.21" style={{ fill: '#1d80b5' }} />
        <ellipse cx="45.48" cy="36.16" rx="1.16" ry="1.21" style={{ fill: '#1d80b5' }} />
        <ellipse cx="77.51" cy="36.16" rx="1.16" ry="1.21" style={{ fill: '#1d80b5' }} />
        <ellipse cx="85.32" cy="36.16" rx="1.16" ry="1.21" style={{ fill: '#1d80b5' }} />
        <ellipse cx="93.03" cy="36.16" rx="1.16" ry="1.21" style={{ fill: '#1d80b5' }} />
        <rect x="6.58" y="2.06" width="2.71" height="68.14" style={{ fill: '#fff' }} />
        <rect x="114.57" y="2.73" width="2.71" height="68.14" style={{ fill: '#fff' }} />

        <text x="13" y="17" style={{ fontSize: 12, fill: '#fff' }}>{phase}</text>
    </svg>)
}

export default SvgInverter